import { render, staticRenderFns } from "./memberUserSection.vue?vue&type=template&id=08e20564&scoped=true"
import script from "./memberUserSection.vue?vue&type=script&lang=js"
export * from "./memberUserSection.vue?vue&type=script&lang=js"
import style0 from "./memberUserSection.vue?vue&type=style&index=0&id=08e20564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e20564",
  null
  
)

export default component.exports